<template>
  <div class="login_top">
    <login-header></login-header>
    <div style="flex:1;">
      <div class="login" :style="adv.style">
        <div class="content_container">
          <div :class="['left_click_box',{'pointer':adv && adv.url !== ''}]" @click="handleUrl(adv.url)"></div>
          <div class="login_box">
            <div class="login_form">
              <div class="login_type_box1" @click="changeLoginMethodByImg">
                <div class="img_44_44 img_wrapper">
                  <img :src="loginMethod === 'wechat' ? require('@/assets/images/login/login_account.png') : require('@/assets/images/login/login_qrcode.png')"  class="pointer" />
                </div>
              </div>
              <div v-if="loginMethod === 'wechat'" >
                <a-tabs default-active-key="wx_scan" @change="scanChange">

                  <a-tab-pane key="wx_scan" tab="微信扫码">
                    <div  class="login_container_class" v-if="!showBindWxBox">
                      <div class="loadimg" v-if="!wxImg"> </div>
                      <img  v-else :src="wxImg" width="180" height="180" style="display: block;margin: 30px auto 0;" alt="">
                      <div class="login_container_class_div">打开<span>{{scanText}}</span>扫一扫登录</div>
                    </div>

                    <bind-wx  class="login_container_class" v-if="showBindWxBox" @submit="submitBind"></bind-wx>
                  </a-tab-pane>

                  <a-tab-pane key="app_scan" tab="APP扫码" force-render>
                    <div class="login_container_app_class" >
                      <img :src="appImg"   class="app_img1" @mouseenter="appEnter" @mouseleave="appLeave" v-bind:class="moveType"  alt="" >
                      <img :src="require('@/assets/images/login/login_slice1.png')"  class="app_img2" v-bind:class="isShow" alt="">
                      <div class="login_container_class_app_div">打开<span> {{scanText}} </span>扫一扫登录</div>
                    </div>
                  </a-tab-pane>
                </a-tabs>
                <div class="login_scan_type_box">
                  <div class="img_scan_115_23 img_wrapper">
                    <img :src="loginMethod === 'wechat' ? require('@/assets/images/login/account_tip.png') : require('@/assets/images/login/qrcode_tip.png')" />
                  </div>
                </div>
              </div>

              <a-form-model ref="loginForm" v-show="loginMethod !== 'wechat'" layout="vertical" :model="loginForm" :rules="rules" >
                <a-tabs default-active-key="userpwd"  v-model="loginMethod" @change="changeLoginMethodByTab">
                  <a-tab-pane key="userpwd" tab="密码登录">
                    <a-form-model-item prop="username" >
                      <div class="input_box">
                        <a-input v-model="loginForm.username" autoComplete="off" placeholder="账号" @keyup.enter="loginValidate" @focus='clearTips' />
                      </div>
                    </a-form-model-item>
                    <a-form-model-item prop="password" >
                      <div class="input_box">
                        <a-input-password v-model="loginForm.password" autoComplete="off" placeholder="密码" @keyup.enter="loginValidate" @focus='clearTips' />
                      </div>
                    </a-form-model-item>
                    <a-form-model-item prop="imgCode">
                      <div class="input_box" >
                        <a-input class="code_input" v-model="loginForm.imgCode" placeholder="验证码" ref="userpwdImgCode" @keyup.enter="loginValidate" @focus='clearTips' />
                        <img :src="imgCode" @click="getImgCode" />
                      </div>

                      <template #help><span class="tips">{{help}}</span></template>
                    </a-form-model-item>
                    <a-form-model-item class="auto_login" prop="remember">
                      <a-checkbox v-model="loginForm.remember" class="font12">
                        下次自动登录
                      </a-checkbox>
                    </a-form-model-item>
                  </a-tab-pane>
                  <a-tab-pane key="mobile" tab="短信登录" force-render>
                    <a-form-model-item prop="mobile">
                      <div class="input_box">
                        <a-input v-model="loginForm.mobile" autocomplete placeholder="手机号码" @focus='clearTips' />
                      </div>
                    </a-form-model-item>
                    <a-form-model-item prop="imgCode">
                      <div class="input_box" >
                        <a-input class="code_input" v-model="loginForm.imgCode" ref="mobileImgCode" placeholder="验证码" @keyup.enter="loginValidate" @focus='clearTips' />
                        <img :src="imgCode" @click="getImgCode" />
                      </div>

                      <template #help><span class="tips">{{help}}</span></template>
                    </a-form-model-item>

                    <a-form-model-item prop="smsCode">
                      <div class="input_box" >
                        <a-input class="code_input" v-model="loginForm.smsCode" placeholder="短信验证码" @keyup.enter="loginValidate" @focus='clearTips' />
                        <span class="btn_sms_code" @click="getSmsCode">{{this.enableGetSmsCode ? '获取验证码' : `${this.smsCodeTime}秒后获取`}}</span>
                      </div>
                    </a-form-model-item>

                    <a-form-model-item class="auto_login" prop="remember">
                      <a-checkbox v-model="loginForm.remember" class="font12">
                        下次自动登录
                      </a-checkbox>
                    </a-form-model-item>
                  </a-tab-pane>
                  <a-tab-pane v-if="showEmail" key="email" tab="邮箱登录" force-render>
                    <a-form-model-item prop="email">
                      <div class="input_box">
                        <a-input v-model="loginForm.email" autocomplete placeholder="请输入邮箱" @focus='clearTips' />
                      </div>
                    </a-form-model-item>
                    <a-form-model-item prop="imgCode">
                      <div class="input_box" >
                        <a-input class="code_input" v-model="loginForm.imgCode" ref="mobileImgCode" placeholder="验证码" @keyup.enter="loginValidate" @focus='clearTips' />
                        <img :src="imgCode" @click="getImgCode" />
                      </div>

                      <template #help><span class="tips">{{help}}</span></template>
                    </a-form-model-item>

                    <a-form-model-item prop="emailCode">
                      <div class="input_box" >
                        <a-input class="code_input" v-model="loginForm.emailCode" placeholder="邮箱验证码" @keyup.enter="loginValidate" @focus='clearTips' />
                        <span class="btn_sms_code" @click="getEmailCode">{{this.enableGetSmsCode ? '获取验证码' : `${this.smsCodeTime}秒后获取`}}</span>
                      </div>
                    </a-form-model-item>

                    <a-form-model-item class="auto_login" prop="remember">
                      <a-checkbox v-model="loginForm.remember" class="font12">
                        下次自动登录
                      </a-checkbox>
                    </a-form-model-item>
                  </a-tab-pane>
                  <!-- <div class="login_type_box">
                    <div class="img_115_23 img_wrapper">
                      <img :src="loginMethod === 'wechat' ? require('@/assets/images/login/account_tip.png') : require('@/assets/images/login/qrcode_tip.png')" />
                    </div>
                  </div> -->
                </a-tabs>

                <a-form-item class="login_btn">
                  <a-button size="large" block type="primary" @click="loginValidate">登录</a-button>
                </a-form-item>

              </a-form-model>
            </div>

            <div class="bottom_btn" v-if="loginMethod != 'wechat'">
              <a-button class="forget_pwd" type="link" @click="toForget">忘记密码?</a-button>
              <a-button class="free_register" type="link" @click="toRegister">免费注册<img :src="require('@/assets/images/login/login_back.png') " /></a-button>
            </div>
            <div class="bottom_scan_btn" v-if="loginMethod === 'wechat'">
              <a-button class="free_scan_register" type="link" @click="toRegister">免费注册<img :src="require('@/assets/images/login/login_back.png') " /></a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <login-footer></login-footer>
  </div>
</template>

<script>
import LoginHeader from './common/login/LoginHeader.vue'
import LoginFooter from './common/login/LoginFooter.vue'
import BindWx from './common/login/BindWx.vue'
import '@/assets/css/resetAntd.css'
import { encrypt } from '../utils/rsa'
import Util from '../utils/util.js'

export default {
  name: 'Login',
  components: {
    LoginHeader,
    LoginFooter,
    BindWx
  },
  created() {
    this.getAdv();
    this.getWxCode();
  },
  mounted() {
    // const s = document.createElement('script');
    // s.type = 'text/javascript';
    // s.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
    // document.body.appendChild(s);
  },
  data () {
    var checkEmail = (rule, value, callback) =>{
      if (!value) {
        return callback(new Error('email不能为空'));
      }
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if(!regex.test(value)){
        console.log('email格式不正确'); 
        return callback(new Error('email格式不正确'));
      }
    };
    return {
      rules: {
        username: [
          { required: true, message: '请输入账号/手机号码', trigger: ['blur', 'change'] }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: ['blur', 'change'] }
        ],
        imgCode: [
          { required: true, message: '请输入验证码', trigger: ['blur', 'change'] }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },
          { validator: this.$validate.mobile, trigger: ['blur', 'change'] }
        ],
        email: [
          { required: true, message: '请输入email', trigger: ['blur', 'change'] },
          { validator: checkEmail, trigger:  ['blur', 'change'] }
        ],
        emailCode: [
          { required: true, message: '请输入动态验证码', trigger: ['blur', 'change'] },
        ],
        smsCode: [
          { required: true, message: '请输入动态验证码', trigger: ['blur', 'change'] }
        ]
      },
      adv: {
        style: {
          backgroundImage: `url(${require('@/assets/images/login/bg.png')})`
        },
        url: ''
      },
      loginForm: {
        username: '',
        password: '',
        imgCode: '',
        mobile: '',
        email: '',
        emailCode: '',
        smsCode: '',
        remember: false
      },
      bindForm:{
        imgCode: '',
        mobile: '',
        smsCode: '',
      },
      loginMethod: 'wechat',
      enableGetSmsCode: true,
      smsCodeTime: 60,
      redirect: null,
      otherQuery: {},
      imgCode: '',
      help:'',
      wxImg:'',
      imgKey: '',
      scanText:'微信',
      isShow:'img2_hide',
      moveType:'move_right',
      appImg:'',
      appTicket:'',
      myVar:'',
      showBindWxBox:false,
      public_weixin_unionid:'',
      showEmail: true,
      ip_country: false,
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
        if(to.name == 'Login'){
          vm.$util.api_login("/login/status", {}, function (res) {
            // vm.$cookies.remove("UserInfo");
            // vm.$cookies.remove("AccessToken");
            // vm.$cookies.remove("AccessToken",'','91jf.com');
            // vm.$cookies.remove("mobile");
            // vm.$cookies.remove("EndTime");
            if (res.code == 10000) {
              next({
                    path: '/'
              })
            }else{
              vm.$cookies.remove("UserInfo");
              vm.$cookies.remove("AccessToken");
              vm.$cookies.remove("AccessToken",'','91jf.com');
              vm.$cookies.remove("mobile");
              vm.$cookies.remove("EndTime");
            }
          });
        }
    })
  },
  methods: {
    getAdv () {
      var _this = this;

      _this.$util.api('/adv/login',{},function(res){
        if(res.code == 10000){
          if(res.data.adv_img !=''){
            _this.adv.url = res.data.adv_url;
            _this.adv.style.backgroundImage = `url(${res.data.adv_img})`;
          }
        }
      });
    },
    getImgCode() {
      var _this = this;

      _this.$util.api('/code',{},function(res){
        if(res.code == 10000){
          _this.imgCode = res.data.img;
          _this.imgKey = res.data.key;
        }
      });
    },
    getEmailCode() {
      if (!this.enableGetSmsCode) return
      let validateStatus = true
      this.$refs.loginForm.validateField(['email', 'imgCode'], (errorMessage) => {
        if (errorMessage) {
          validateStatus = false
        }
      })
      if (validateStatus) {
        var _this = this;
        let params = {
          email: this.loginForm.email,
          code: this.loginForm.imgCode + ',' + this.imgKey,
        };
        _this.$util.api('/email/code',params,function(res){

          if(res.code == 10000){
            _this.enableGetSmsCode = false
            let countDown = setInterval(() => {
              --_this.smsCodeTime
              if (_this.smsCodeTime === 0) {
                clearInterval(countDown)
                _this.enableGetSmsCode = true
                _this.smsCodeTime = 60
              }
            }, 1000)
          }else{
            //报错
            _this.help=res.msg;
          }
        })
      }
    },
    loginValidate () {
      //登录提交
      this.isShowVcode = true
      const { loginMethod } = this
      let fieldKeys = []

      if (loginMethod === 'userpwd') {
        fieldKeys = ['username', 'password', 'imgCode']
      } else if (loginMethod === 'mobile') {
        fieldKeys = ['mobile', 'smsCode', 'imgCode']
      } else if (loginMethod === 'email') {
        fieldKeys = ['email', 'emailCode', 'imgCode']
      }

      let validate = true
      this.$refs.loginForm.validateField(fieldKeys, err => {
        if (err) validate = false
      })

      if (!validate) return

      let params = {}

      if (loginMethod === 'userpwd') {
        //账密登录
        params = {
          username: this.loginForm.username,
          password: this.loginForm.password,
          code: this.loginForm.imgCode + ',' + this.imgKey
        }
        var _this = this;
        _this.$util.api('/login/account',params,function(res){

          if(res.code == 10000){
            //设置cookie
            _this.$cookies.set('AccessToken',res.data.token_type + ' ' + res.data.access_token,'86400','/','91jf.com');
            let fail_time = (new  Date().getTime()/1000)+res.data.expire_in
            _this.$cookies.set('EndTime',fail_time);
            //是否记住账号密码
            if (_this.loginForm.remember) {
              _this.$cookies.set('username',params.username);
              _this.$cookies.set('password',params.password);
            }
            //跳转
            // _this.$router.push('/')
            // location.href='/'
            _this.handleLoginSuccess(loginMethod);

          }else{
            //获取失败
            _this.getImgCode();
            //报错
            _this.help=res.msg;

          }
        });

      } else if (loginMethod === 'mobile') {
        //手机号登录
        params = {
          mobile: this.loginForm.mobile,
          code: this.loginForm.smsCode
        }

        var _this = this;
        _this.$util.api('/login/sms',params,function(res){
          // console.log(res);
          if(res.code == 10000){
            //设置cookie
            _this.$cookies.set('AccessToken',res.data.token_type + ' ' + res.data.access_token,'86400','/','91jf.com');
            let fail_time = (new  Date().getTime()/1000)+res.data.expire_in
            _this.$cookies.set('EndTime',fail_time);

            //是否记住账号密码
            if (_this.loginForm.remember) {
              _this.$cookies.set('mobile',_this.loginForm.mobile);
            }
            //跳转
            // _this.$router.push('/')
            _this.handleLoginSuccess();

          }else{
            //报错
            _this.help=res.msg;
          }
        })
      } else if (loginMethod === 'email') {
        params = {
          email: this.loginForm.email,
          email_code: this.loginForm.emailCode,
          code: this.loginForm.imgCode + ',' + this.imgKey
        }

        var _this = this;
        _this.$util.api('/login/email',params,function(res){
          // console.log(res);
          if(res.code == 10000){
            //设置cookie
            _this.$cookies.set('AccessToken',res.data.token_type + ' ' + res.data.access_token,'86400','/','91jf.com');
            let fail_time = (new  Date().getTime()/1000)+res.data.expire_in
            _this.$cookies.set('EndTime',fail_time);

            //是否记住账号密码
            if (_this.loginForm.remember) {
              _this.$cookies.set('email',params.email);
            }
            //跳转
            // _this.$router.push('/')
            _this.handleLoginSuccess();

          }else{
            //报错
            _this.help=res.msg;
          }
        })
      }
    },
    handleUrl (url) {
      if (url === '') return
      window.open(url, '_blank')
    },
    getSmsCode () {
      if (!this.enableGetSmsCode) return
      let validateStatus = true
      this.$refs.loginForm.validateField(['mobile', 'imgCode'], (errorMessage) => {
        if (errorMessage) {
          validateStatus = false
        }
      })
      if (validateStatus) {
        //获取手机短信
        var _this = this;
        let params = {
          mobile: this.loginForm.mobile,
          code: this.loginForm.imgCode + ',' + this.imgKey,
          action: 'login'
        };
        _this.$util.api('/sms',params,function(res){

          if(res.code == 10000 && _this.loginForm.mobile==res.data){
            _this.enableGetSmsCode = false
            let countDown = setInterval(() => {
              --_this.smsCodeTime
              if (_this.smsCodeTime === 0) {
                clearInterval(countDown)
                _this.enableGetSmsCode = true
                _this.smsCodeTime = 60
              }
            }, 1000)
          }else{
            //报错
            _this.help=res.msg;
          }
        })
      }
    },
    changeLoginMethodByTab () {
      this.$refs.loginForm.clearValidate()
      //刷新验证码，并且清空输入框
      this.imgCode = '';
      this.imgKey = '';
      this.getImgCode();
    },
    scanChange(key){
      //微信扫码
      if(key==='wx_scan'){
        this.scanText='微信'
        clearInterval(this.myVar);
      }
      //APP扫码
      if(key==='app_scan'){
        this.scanText='91家纺网APP'
        var _this = this;

        _this.$util.api('/login/qrcode',{},function(res){
          if(res.code == 10000){
            _this.appImg = res.data.qrcode;
            _this.appTicket = res.data.ticket;

            _this.get_app_res();
          }
        });

      }

    },
    //轮询app扫码结果
    get_app_res(){
      var _this = this;
      _this.myVar =setInterval(function(){
        if(_this.appTicket!=''){

          _this.$util.api('/login/scan',{'ticket':_this.appTicket},function(res){
            if(res.code == 10000){
              //设置cookie
              _this.$cookies.set('AccessToken',res.data.token_type + ' ' + res.data.access_token,'86400','/','91jf.com');
              let fail_time = (new  Date().getTime()/1000)+res.data.expire_in
              _this.$cookies.set('EndTime',fail_time);

              clearInterval(_this.myVar);
              _this.handleLoginSuccess();

            }
            if(json.code == 30125){
              location.href='/login';
            }
          });
        }

      },3000 )//轮询执行
    },
    changeLoginMethodByImg () {
      if(this.ip_country === false){
        // this.getIP();
      }
      if (this.loginMethod === 'wechat') {
        clearInterval(this.myVar);
        this.loginMethod = 'userpwd'
        this.getImgCode();
      } else {
        this.loginMethod = 'wechat'
        // this.createWxQrcode()
        this.getWxCode()
      }
    },
    toRegister () {
      clearInterval(this.myVar);
      this.$router.push({path: '/reg/person', query: {is_show:1}})
    },
    toForget () {
      clearInterval(this.myVar);
      this.$router.push('/forget')
    },
    appEnter(){
      this.isShow='img2_show'
      this.moveType='move_left'
    },
    appLeave(){
      this.isShow='img2_hide'
      this.moveType='move_right'
    },
    clearTips(){
      this.help='';
    },
    //获取公众号登录的二维码
    getWxCode() {
      // var _this = this;
      this.$util.api('/login/wximg',{},(res)=>{
        if(res.code == 10000){
          return new Promise((resolve, reject)=> {
            this.wxImg =res.data.qrcode;
            if(this.wxImg !==''){
              setTimeout(()=>{
                resolve();
              },1000)
            }
          }).then((val)=>{
            this.wxLogin(res.data.key);
          }).catch((error)=>{

          });
          //验证用户扫码登录
        }
      });
    },
    wxLogin(token){
      var _this = this;
      _this.myVar =setInterval(function(){
        if(token!=''){

          _this.$util.api('/login/check',{token:token},function(res){
            if(res.code == 10000){
              //设置cookie
              _this.$cookies.set('AccessToken',res.data.token_type + ' ' + res.data.access_token,'86400','/','91jf.com');
              let fail_time = (new  Date().getTime()/1000)+res.data.expire_in
              _this.$cookies.set('EndTime',fail_time);
              clearInterval(_this.myVar);
              _this.handleLoginSuccess();

            }else if(res.code==30154){
              clearInterval(_this.myVar);
              _this.public_weixin_unionid = res.msg;
              _this.showBindWxBox=true;
            }
          });
        }

      },3000 )//轮询执行
    },
    submitBind(params){
      var _this = this;
      let pars = {
        'mobile':params.mobile,
        'smsCode':params.smsCode,
        'public_weixin_unionid':_this.public_weixin_unionid
      }
      _this.$util.api('/login/bind',pars,function(res){
        if(res.code == 10000){

          //设置cookie
          _this.$cookies.set('AccessToken',res.data.token_type + ' ' + res.data.access_token,'86400','/','91jf.com');
          let fail_time = (new  Date().getTime()/1000)+res.data.expire_in
          _this.$cookies.set('EndTime',fail_time);

          clearInterval(_this.myVar);
          _this.handleLoginSuccess();
        }else{
          _this.$message.success(res.msg)
        }
      });
    },
    getIP(){
      var _this = this;
      _this.$util.api('/ip/country',{},function(res){
        if(res.code == 10000){
          _this.ip_country = res.data;
          if(res.data!=='中国' && res.data!=''){
            _this.showEmail = true;
          }
        }
      });
    },
    // 统一的登录成功跳转处理方法
    handleLoginSuccess(loginMethod = "") {
      // 获取URL参数
      const urlParams = new URLSearchParams(window.location.search);
      const source = urlParams.get('source');
      
      // 判断source参数
      if (source === 'ai') {
        location.href = 'https://ai.91jf.com';
      } else {
        // 原有逻辑中 只有 userpwd 登录方式 才会跳回上一页 这边兼容保留
        if(loginMethod === 'userpwd'){
          // _this.$router.go(-1);
          location.href = '/';
        }
        // 原有的跳转逻辑
        location.href = '/';
      }
    }
  }
}
</script>

<style scoped>
.login_top{
  background-color: #fff;
}
.login {
  width: 100%;
  height: 600px;
  margin-top: 10px;
  background: url(https://img2.91jf.com/qcloud/adv/20201230/20201230111436_212.jpg) no-repeat center;
  background-size: auto 100%;
}
.wx_login_wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  min-height: 300px;
}

.body {
  width: 100%;
  height: 600px;
  margin-top: 10px;
  /* background: url(https://img2.91jf.com//qcloud/adv/20201230/20201230111436_212.jpg)
    no-repeat center; */
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
}

.font12 {
  color: #666666;
  font-size: 12px;
}
.auto_login {
  height: 15px;
}
.content_container {
  width: 100%;
  height: 100%;
  /* height: 600px; */
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 auto;
  /* padding: 0 200px; */
  box-sizing: border-box;
}
.content_container .left_click_box {
  width: 50%;
  height: 400px;
}
.content_container .login_box {
  width: 400px;
  min-height: 420px;
  background: #ffffff;
  position: relative;
  border-radius: 4px;
  margin: 25px;
}

.content_container .login_box .login_type_box {
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 10px;
}

.content_container .login_box .input_box {
  width: 100%;
  /* border: 1px solid #D8D8D8; */
  display: flex;
  align-items: center;
}
.content_container .login_box .input_box >>> input {
  width: 100%;
  height: 50px;
  border-radius: 8px;
  border: 1px solid #D8D8D8;
  padding: 15px 12px;
}
.content_container .login_box .input_box >>> input:focus {
  outline: none;
}
.content_container .login_box .img_code {
  /* width: 115px; */
  /* height: 40px; */
  margin-left: 10px;
  border: 1px solid #d8d8d8;
  cursor: pointer;
}
.register_btn {
  text-align: center;
}
.register_btn:hover {
  color: #fd5902;
}

.btn_sms_code {
  line-height: 50px;
  text-align: center;
  font-size: 14px;
  color: #fd5902;
  cursor: pointer;
  margin-left: 12px;
  border: 1px solid #D8D8D8;
  color: #333333;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  border-radius: 8px;
  width: 94px;
  height: 50px;
}

.login >>> .ant-form-item-children {
  display: flex;
  width: 360px;
  height: 50px;
}

.login >>> .ant-form-item-children img {
  margin-left: 12px;
  width: 94px;
  height: 50px;
  align-items: center;
  border-radius: 8px;
}

.login >>> .ant-form-vertical .ant-form-item {
  margin-bottom: 10px;
}
.login >>> .ant-tabs-top-content {
  padding-top: 0px;
}
.login >>> .ant-btn-lg {
  /* height: 50px; */
  font-size: 18px;
}

.login >>> .ant-btn-link {
  display: block;
  margin: 0 auto;
  color: #666666;
  font-size: 14px;
}
.login >>> .ant-tabs-bar {
  margin: 0 0 16px 0;
  /* border-bottom: 1px solid #e8e8e8; */
  outline: none;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.login >>> .ant-btn-link:hover {
  color: #fd5902;
}


.img_115_23 {
  width: 82px;
  height: 23px;
  margin-top: 8px;
}
.img_44_44 {
  width: 50px;
  height: 50px;
  z-index: 100;
}

.tips{
  color:#f5222d;
}
.login_btn{
  margin-bottom: 0px !important;
}
.login_container_class{
  width: 300px;
  height: 270px;
  margin:0 auto;
  padding-top: 10px;
  overflow: hidden;
}
.login_container_class img{
  width: 150px;
  height: 150px;
}
.login_container_class_div{
  width: 180px;
  height: 19px;
  line-height: 19px;
  color: #333333;
  font-size: 14px;
  margin: 16px auto 0;
  text-align: center;
}

.login_container_class_div span{
  margin: 0 5px;
  color: #18A112;
}

.login_container_app_class{
  width: 300px;
  height: 270px;
  margin:0 auto;
  padding-top: 40px;
  overflow: hidden;
  position: relative;
}

.login_container_class_app_div{
  width: 205px;
  height: 19px;
  line-height: 19px;
  color: #333333;
  font-size: 14px;
  margin: 16px auto 0;
  text-align: center;
}
.login_container_class_app_div span{
  margin: 0 5px;
  color: #FD5902;
}

.login >>> .ant-tabs-line .ant-tabs-nav-wrap {
  text-align: left;
  font-size: 18px;
  font-weight: 200;
}
.login >>> .login_type_box1{
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  position: absolute;
  top: 0px;
  right: 0px;
}

.login >>> .ant-tabs-nav .ant-tabs-tab:active, .ant-tabs-nav .ant-tabs-tab:hover, .ant-tabs-nav .ant-tabs-tab-active {
  color: #333333;
  font-size: 18px;
  font-weight: 600;
}
/* .login >>> .ant-tabs-nav .ant-tabs-tab:hover {
    color: #333333;
    font-size: 18px;
    font-weight: 500;
} */
.login >>> .ant-tabs-nav .ant-tabs-tab-active {
  color: #333333;
  font-size: 18px;
  font-weight: 100;
  text-shadow: 0 0 0.25px currentColor;
}

.login >>> .ant-tabs-nav .ant-tabs-tab{
  margin: 0px 22px 0 0;
  font-size: 16px;
}

.login >>> .ant-tabs-nav .ant-tabs-tab{
  padding: 4px 0px;
}
.login >>> .ant-input{
  border-radius: 0;
  padding: 0;
}

.login >>> .ant-input:focus, .ant-input:hover {
  -webkit-box-shadow: 0 0 0 0 ;
  box-shadow: 0 0 0 0 ;
}
.login >>> .ant-tabs-nav-scroll{
  margin-top: 16px;
}
.login >>> input,textarea{outline:none}
.login >>> textarea{resize:none}

.login >>> .ant-input:focus, .ant-input:hover {
  border-color: #ffff;
  -webkit-box-shadow: none;
  box-shadow:none;
}
.login >>> .ant-input-affix-wrapper .ant-input:hover {
  /* border: none; */
  box-shadow: none;
}

.login >>> .bottom_btn{
  width: 400px;
  height: 50px;
  background-color: #FAFAFA;
}
.login >>> .forget_pwd{
  float: left;
  color: #666666;
  font-size: 14px;
  margin-top: 15px;
}

.login >>> .free_register{
  float: right;
  color: #333333;
  font-size: 14px;
  margin-top: 15px;
}

.login >>> .bottom_scan_btn{
  width: 400px;
  height: 50px;
  position: absolute;
  bottom: 0px;
  background-color: #FAFAFA;
}

.login >>> .free_scan_register{
  float: right;
  color: #333333;
  font-size: 14px;
  line-height: 32px;
}
.login >>> .free_scan_register img{
  width: 8px;
  height: 8px;
  margin-left: 4px;
  margin-bottom: 2px;
}
.login >>> .free_scan_register .ant-btn{
  padding: 5px 15px;
  height: 44px;
}
.login >>> .free_register img{
  width: 8px;
  height: 8px;
  margin-left: 4px;
  margin-bottom: 2px;
}
.login >>> .login_form{
  padding: 0px 20px;
}
.login_scan_type_box {
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 37px;
}

.login >>> .img_scan_115_23 {
  width: 102px;
  height: 23px;
  margin-top: 8px;
}

.login >>> .app_img1{
  width: 150px;
  height: 150px;
}
.login >>> .app_img2{
  width: 99px;
  height: 170px;
  position: absolute;
  right: 20px;
  top: 30px;
}
.move_left{
  margin-left: 20px;
  transition: all .6s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.move_right{
  margin-left: 74px;
  transition: all .6s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.img2_show{
  opacity: 1;
  transition: all 1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.img2_hide{
  opacity: 0;
  transition: all .6s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.login >>> .ant-input:focus,.login >>> .ant-input:hover{
    /* border-color: transparent !important; */
    box-shadow: none !important;
}
>>>.ant-form-vertical .ant-form-explain {
    margin-top: 2px;
    margin-bottom: -24px!important;
}

@keyframes blink {
    0%, 100% {
      opacity: 1; /* 完全不透明 */
    }
    30%{
      opacity: 0.3; /* 半透明 */
    }
    50% {
      opacity: 0.5; /* 半透明 */
    }
  }
.loadimg{
  width: 150px;
  height: 150px;
  background-color: #e0e0e0; /* 骨架屏的背景颜色 */
  animation: blink 1.5s infinite; /* 应用闪烁动画 */
  margin: 30px auto 0;
}
.content_container .login_box .input_box .code_input{
  width: 254px;
}
.login  >>> .ant-btn-link:hover{
  border: unset;
}
.login  >>> .ant-btn{
  transition: unset;
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue